/*  Shared  */
import { Helpers, SessionHelper } from 'application/Shared/Helpers';
import { Env } from 'application/Shared/Utils';

/* Hooks */
import { useFetchTenant } from 'hooks/dataAccess/Tenant/tenant';
import { useSession } from 'hooks/redux/Selectors/session';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

/*  Components  */
import { IconForTab } from '../Sidebar/internal/SidebarIcons';
import { Tab } from './Tab';

export const AnmTab = () => {
    const session = useSession();
    const { t } = useTranslation();
    const { partnerId } = useParams();

    const { tenant } = useFetchTenant({ clientId: partnerId });

    const identityTenantDomain = tenant?.identityTenantDomain;

    const anmAppLink = identityTenantDomain
        ? `https://${identityTenantDomain}.my.auvik.com`
        : Env.get('REACT_APP_ANM_OKTA_APP_LINK');

    const sessionHelper = new SessionHelper(session);
    const anmTenantReservedStatus = sessionHelper.getAnmTenantReservedStatus();

    if (!anmTenantReservedStatus) {
        return null;
    }
    const { error, reservedInfo } = anmTenantReservedStatus;
    if (error || Helpers.isEmpty(reservedInfo)) {
        return null;
    }

    // ANMTab is only shown at the partner level.
    const routeProp = reservedInfo.reserved
        ? `/partner/${partnerId}/anmTrial`
        : { pathname: anmAppLink };

    return (
        <Tab
            permission={['partner', 'system_admin']}
            icon={<IconForTab src="NetworkMapAuvikAgent" />}
            route={routeProp}
            name={<span>{t('Sidebar.return_to_auvik')}</span>}
            style={{
                '&:hover': {
                    backgroundColor:
                        'sidebar.item.bottomItemHover.backgroundColor'
                },
                color: 'sidebar.text',
                paddingLeft: '8px',
                paddingRight: '2px'
            }}
            subTab
        />
    );
};
